module.exports = __webpack_public_path__ + "static/media/icon-nav-trading.3fcf73a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-nav-trading.svg
// module id = 1215
// module chunks = 19